module.exports = __webpack_public_path__ + "static/img/BookingHover.b66aaca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/BookingHover.png
// module id = aF3Q
// module chunks = 0